// Selector to get all the items in the wishlist
export const selectWishlistItems = (state) => state.wishlist.items;

// Selector to check if a product is in the wishlist
export const selectIsProductInWishlist = (state, productId) =>
  state.wishlist.items.some((item) => item.id === productId);
